import React, { Component } from 'react';
import '../../css/style.css';
import '../Home.css';
import { Card, Row, Col, Button, Form, OverlayTrigger, Tooltip, Alert, Table } from 'react-bootstrap';
import { getURL, sendJson, EVENT_IMG_URL, WEB_URL, GOOGLEMAP_URL } from '../../backend/Backend';
import { translate } from "react-i18next";
import { getDatesDisplayValue, getLocationDisplay } from '../../backend/UIUtils';
import PublicEventBooking from './PublicEventBooking';
import { getCountries } from '../../backend/Countries';
import i18n from "i18next";

import AuthenticationService from '../../backend/AuthenticationService';
import Sharing from '../util/Sharing';
import EventNotify from '../user/EventNotify';
import { Link } from 'react-router-dom';



class PublicEventShowItem extends Component {

  constructor(props) {
    super(props);
    this.eevBookingSelected = this.eevBookingSelected.bind(this);
    this.executeBooking = this.executeBooking.bind(this);
    this.addFavorite = this.addFavorite.bind(this);
    this.addSubscription = this.addSubscription.bind(this);
    this.notifyEvent = this.notifyEvent.bind(this);


    this.state = {
      selected: '',
      userId: '',
      favorite: false,
      subscription: false,
      bookingCounter: null,
      eevBooking: true,
      favMessage: '',
      aboMessage: ''
    };
  }





  async componentDidMount() {
    let oldState = this.state;


    if (AuthenticationService.isUserLoggedIn()) {
      let user = AuthenticationService.getLoggedUser();
      const response = await fetch(getURL(`p-events/${this.props.id}/${user.id}`));
      const json = await response.json();
      this.setState({
        ...oldState,
        selected: json.event,
        favorite: json.favorite,
        subscription: json.subscription,
        bookingCounter: json.bookingCounter,
        eventId: this.props.eventId,
        userId: user.id
      })
    } else {
      const response = await fetch(getURL(`p-events/${this.props.id}/0`));
      const json = await response.json();
      this.setState({
        ...oldState,
        selected: json.event,
        bookingCounter: json.bookingCounter,
        eventId: this.props.eventId
      })
    }
  }

  eevBookingSelected() {
    let oldState = this.state;
    this.setState(
      {
        ...oldState,
        eevBooking: true
      }
    );
  }

  executeBooking() {
    let oldState = this.state;
    this.setState(
      {
        ...oldState,
        eevBooking: false
      }
    );
  }

  async addFavorite() {
    if (this.state.userId) {
      let oldState = this.state;
      let fav = this.state.favorite;
      const response = fav ?
        await fetch(getURL(`p-events/removeFav/${this.props.id}/${this.state.userId}`)) :
        await fetch(getURL(`p-events/addFav/${this.props.id}/${this.state.userId}`));
      const json = await response.json();
      if (json.ok) {
        this.setState({
          ...oldState,
          favorite: !fav,
          favMessage: !fav ? 'favoriteAdded' : 'favoriteDeleted'
        });
        setTimeout(() => this.setState({ favMessage: '' }), 1000);
      }
    }

  }

  async addSubscription() {
    if (this.state.userId) {
      let oldState = this.state;
      let subs = this.state.subscription;
      const response = subs ?
        await fetch(getURL(`subscription/remove/${this.state.selected.creationUserId}/${this.state.userId}`)) :
        await fetch(getURL(`subscription/add/${this.state.selected.creationUserId}/${this.state.userId}`));
      const json = await response.json();
      if (json.ok) {
        this.setState({
          ...oldState,
          subscription: !subs,
          aboMessage: !subs ? 'subscripeAdded' : 'subscripeDeleted'
        });
        setTimeout(() => this.setState({ aboMessage: '' }), 1000);
      }
    }

  }

  notifyEvent(comment) {
    console.log("notify  comment "+comment)
      let item  = {'comment': comment, 'publicEventId':this.props.id, 'userId':this.state.userId};

    
      sendJson('post', 'notify', item).then(
          received => {
            if(received.ok){
              this.setState({
                favMessage:  'favoriteAdded' 
              });
              setTimeout(() => this.setState({ favMessage: '' }), 1000);
            }
            
          });
  }

 
  //<i class="far fa-flag"></i>
  //img-fluid 
  render() {
    const { t } = this.props;
    let lang = i18n.language;
    let countries = getCountries(lang);


    let locationDisplay = getLocationDisplay(this.state.selected, countries)

    let showBooking = !this.state.selected.maxParticipants || this.state.bookingCounter.bookedTotal < this.state.selected.maxParticipants;

    return (
      <div >
        <Row className="justify-content-md-center" >
          <Col className=" mb-2  mt-2 " md={6} xs={12}>

            <Card >
              <Card.Img variant="top" src={this.state.selected.imageName ? EVENT_IMG_URL + this.state.selected.imageName : "/img/produkt-premium-3.jpg"} 
                    className="eImg " height={"100px"}/>
            </Card>
          </Col>
          <Col className=" mb-2  mt-2 " md={6} xs={12}>
            <Card border="light" style={{ "height": "100%" }}>
              <Card.Body>
                <Card.Title className="mb-0">
                  <Row>
                    <Col xs="12" lg={12}>
                      <h3 className="card-title text-primary"> {this.state.selected.title}</h3>
                    </Col>
                  </Row>
                </Card.Title>
                <Row>
                  <Col xs={6} lg={8}>
                    <Form inline>
                      <i className="text-info fa fa-user s16  mr-1" ></i>{this.state.selected.creationUserName}
                      <Button onClick={this.addSubscription} variant="link">{t(this.state.subscription ? "subscriped" : "subscripe")}</Button>
                    </Form>
                  </Col>
                  

                </Row>
                

                <Table borderless={true}>
                      <tbody>
                        <tr>
                          <td style={{ "padding": "0", "textAlign": "left" }}>
                          <OverlayTrigger
                      key="top"
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-top`}>
                          {t(this.state.favorite ? "removeFavorite" : "addFavorite")}
                        </Tooltip>
                      } className="float-right" >
                         {this.state.userId ? 
                      <Button onClick={this.addFavorite} variant="link" className="float-left">
                        {this.state.favorite ?
                          <i class="fas fa-bookmark s24 mr-2  "></i>
                          :
                          <i class="far fa-bookmark s24 mr-2"></i>
                        }
                        { t(this.state.favorite ? "entfernen" : "speichern")}
                      </Button>
                      :
                      <Link to= {`/checkLogin/showevent/${this.props.id}`} ><i class="far fa-bookmark s24  mr-2 "></i>{t('speichern')}</Link> 
                     }
                    </OverlayTrigger>
                          </td>
                          <td style={{ "padding": "0", "textAlign": "right" }}>
                            {this.state.userId ? 
                              <EventNotify variant={"link"} label={t('notify')}
                              action={this.notifyEvent}
                              title={"notifyPublicEventTitle"} text={"notifyPublicEventComment"} accept={"send"} />
                              :
                              <Link to= {`/checkLogin/showevent/${this.props.id}`} ><i class="far fa-flag s24 mr-2 "></i>{t('notify')}</Link>                            
                            }
                          
                          </td>
                        </tr>
                      </tbody>
                    </Table>

                {this.state.favMessage ?
                  <Alert variant="info">
                    {t(this.state.favMessage)}
                  </Alert>
                  :
                  ''
                }
                {this.state.aboMessage ?
                  <Alert variant="info">
                    {t(this.state.aboMessage)}
                  </Alert>
                  :
                  ''
                }
                <Row>
                  <Col>
                    <Table borderless={true} className="mt-0">
                      <tbody>

                        {this.state.selected.startDate ?
                          <tr className="mt-3">
                            <td style={{ "width": "10px", "padding": "0" }}><i className="text-info fa fa-clock s16  mr-3 " ></i></td>
                            <td style={{ "padding": "0" }}>{getDatesDisplayValue(this.state.selected.startDate, this.state.selected.endDate, this.state.selected.sameDay, 'de')}</td>
                          </tr>
                          : ''}
                        {locationDisplay ?
                          <tr>
                            <td style={{ "width": "10px", "padding": "0" }}><i className="text-info fa fa-map-marker-alt s16  mr-3 " ></i></td>
                            <td style={{ "padding": "0" }}><a href={`${GOOGLEMAP_URL}${encodeURIComponent(locationDisplay)}`} data-href={`${GOOGLEMAP_URL}DATA`} data-action="share/googlemap/share"
                              role="link" tabindex="1" target="_blank" data-channel="map" className="mr-2" >{locationDisplay} </a></td>
                          </tr>
                          : ''}
                        {this.state.selected.eventLink ?
                          <tr>
                            <td style={{ "width": "10px", "padding": "0" }}><i className="text-info fa fa-globe s16  mr-3" ></i></td>
                            <td style={{ "padding": "0" }}><a href={this.state.selected.eventLink} data-href={`EVENTLINKDATA`} data-action="share/eventLinl/share"
                              role="link" tabindex="1" target="_blank" data-channel="eventLink" className="mr-2" >{this.state.selected.eventLink} </a></td>
                          </tr>
                          : ''}
                        {(this.state.selected.bookingLink && this.state.selected.bookingType === 'EXTERN') ?
                          <tr>
                            <td style={{ "width": "10px", "padding": "0" }}><i className="text-info fa fa-calendar-check s16 mr-3  " ></i></td>
                            <td style={{ "padding": "0" }}>{this.state.selected.bookingLink}</td>
                          </tr>
                          : ''}
                        {this.state.bookingCounter && this.state.bookingCounter.id ?
                          <tr>
                            <td style={{ "width": "10px", "padding": "0" }}><i className="text-info fa fa-users s16 mr-3  " ></i></td>
                            <td style={{ "padding": "0" }}>
                              {this.state.selected.maxParticipants && this.state.selected.maxParticipants > 0 ?
                                <div>{t("maximal") + ": " + this.state.selected.maxParticipants}
                                  <br></br>
                                  {t("available") + ": " + (this.state.selected.maxParticipants - this.state.bookingCounter.bookedTotal)}
                                </div>
                                :
                                ''
                              }
                            </td>
                          </tr>
                          :
                          ''
                        }

                      </tbody>
                    </Table>
                 


                    {(showBooking && !this.state.eevBooking && this.state.selected.bookingType === 'INTERN') ?
                      <Row className="mt-2">
                        <Col xs={4} lg={2}>
                          <Button onClick={() => this.eevBookingSelected()} className="float-left">
                            {" " + t("Ibook")}
                          </Button>
                        </Col>

                      </Row>
                      :
                      ''
                    }

                  </Col>
                </Row>
              </Card.Body>

            </Card>
          </Col>

        </Row>
        <Row className="bg-light">
          <Col md={6} xs={12}>
            {this.state.selected.description ?
              <Alert style={{ "height": "100%" }}>
                {this.state.selected.description}<br /><br />
              </Alert>
              : ''}
          </Col>

          <Col md={6} xs={12}>
            {(showBooking && this.state.eevBooking && this.state.selected.bookingType === 'INTERN') ?
              <Row >
                <Col xs={12} lg={12}>
                  <PublicEventBooking executeBooking={this.executeBooking} eventId={this.props.id} userMinAge={this.state.selected.userMinAge} />
                </Col>
              </Row>
              :
              ''
            }
          </Col>

        </Row>

        <Row className="mt-2 mb-2">

          <Col lg={8} xs={12} md="auto" md={{ span: 3, offset: 3 }}>
            <Sharing id={this.props.id} url={WEB_URL + "showevent/" + this.props.id} shareLabel={true} facebook={true} twitter={true} />
          </Col>

        </Row>
      </div>
    );
  }
}

export default translate("translations")(PublicEventShowItem);